import { goToLink } from "../../utils/browser-utils.js";
import { BaseComponent } from '../../base.component.js';

export class AbButton extends BaseComponent {

  /**
   * @typedef {RenderableProps} _AbButton_Props
   * @property {'button'|'link'|'icon'} type
   * @property {string} caption
   * @property {string} icon
   * @property {boolean} [iconFlip = false]
   * @property {string} [href] applies to links
   * @property {boolean} [newTab = true] applies to links
   * @property {'lg'|'md'|'sm'} [size = 'md']
   * @property {string} [className]
   * @property {function()} onClick
   * @property {boolean} [stopPropagation]
   */
  render({ type, caption, icon, iconFlip, href, newTab = true, size = 'md', className, onClick, stopPropagation, children }, _, { imgGlobal, txt }) {
    const click = event => {
      stopPropagation && event.stopPropagation();
      if (href) {
        goToLink(txt(href));
      } else if (onClick) {
        onClick(event);
      }
    };

    const src = imgGlobal(icon);
    const contents = (
      <div className="ab-button-contents">
        {icon && <img src={src} alt={icon} className={`ab-button-img ${iconFlip ? 'ab-flip-x' : ''}`} onError={() => this.badgeService.notifyImageError(src)} />}
        {(type !== 'icon') && caption && <span>{txt(caption)}</span>}
        {children}
      </div>
    );

    return (
      <div className={`ab-button ab-button-${type} ${className || ''} ab-size-${size}`}>
        {(type === 'button' || type === 'icon') &&
          <button type="button" onClick={click}>
            {contents}
          </button>
        }
        {(type === 'link') &&
          ((txt(href) || onClick)
            ?
            <a href={txt(href)} target={newTab ? '_blank' : ''} >
              {contents}
            </a>
            :
            <a class='inactive'>
              {contents}
            </a>
          )
        }
      </div>
    );
  }

}
